import React from "react";
import Spinner from "@atlaskit/spinner";
import { ATLButton, Content, Icon, SpinnerContainer } from "./styled";
import { Add, Check } from "./Icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useEffect } from "react";

function AddToLibraryButton({
  macroName,
  onClick = () => {},
  isSaved = false,
  isLoading = false,
  hasChanges = false,
}) {
  const { t } = useTranslation();

  const [shouldNotify, setShouldNotify] = useState(false);

  const hasBeenAdded = isSaved && !hasChanges && shouldNotify;
  const canAdd = !isSaved && !hasChanges;
  const canEdit = isSaved && hasChanges;

  const isClickable = canAdd || canEdit;

  useEffect(() => {
    if (shouldNotify) {
      setTimeout(() => {
        setShouldNotify(false);
      }, 3000);
    }
  }, [shouldNotify]);

  return (
    <ATLButton
      isClickable={isClickable}
      onClick={() => {
        if (canAdd) {
          onClick("create");
          setShouldNotify(true);
        }
        if (canEdit) {
          onClick("edit");
        }
      }}
    >
      {isLoading ? (
        <SpinnerContainer>
          <Spinner size="medium" />
        </SpinnerContainer>
      ) : (
        <>
          {hasBeenAdded && (
            <Content isDisabled>
              <Icon>
                <Check />
              </Icon>
              {t("added-to-library")}
            </Content>
          )}
          {canAdd && (
            <Content>
              <Icon>
                <Add />
              </Icon>
              {t("add-to-library", { macroName })}
            </Content>
          )}
          {canEdit && (
            <Content>
              <Icon>
                <Add />
              </Icon>
              {t("save-changes-to-library")}
            </Content>
          )}
        </>
      )}
    </ATLButton>
  );
}

export default AddToLibraryButton;
